import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from "@mui/material";
import React from "react";

export const SuccessPopup = ({ openDialog, handleConfirmDialog }) => {

    return (
        <>
            <Dialog
                open={openDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Your purchase request has been made successfully."}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Your orders will reach you very soon, happy shopping.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleConfirmDialog} autoFocus>
                        Okay
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

